var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.sectionClasses,style:(_vm.sectionStyles)},[_c('v-container',{class:_vm.containerClass},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }